import { SectionCard } from "@/components/common/SectionCard";
import type { SsdConsentLink } from "@/lib/ssdSalesClient";

function confirmShareOn(name: string): boolean {
  return window.confirm(
    `Let ${name} see your end-customer names, emails, phones, and addresses on Audience Data? They will use this for ads audiences. Continue?`
  );
}

function confirmShareOff(name: string): boolean {
  return window.confirm(
    `Stop sharing end-customer identity with ${name}? They will see your dealership as the customer instead. Continue?`
  );
}

function ConsentList(props: {
  links: SsdConsentLink[];
  sharing: boolean;
  onSetShare: (relationshipId: string, share: boolean) => Promise<boolean>;
}) {
  return (
    <ul className="space-y-3">
      {props.links.map((link) => {
        if (link.role === "manufacturer") {
          return (
            <li key={link.relationship_id} className="text-sm text-gray-700 dark:text-zinc-300">
              {link.share_end_customers ? (
                <>{link.counterpart_name} is sharing end-customer identity with you.</>
              ) : (
                <>
                  {link.counterpart_name} has not shared end-customer identity. Ask them to turn this on in
                  Audience Data.
                </>
              )}
            </li>
          );
        }
        return (
          <li key={link.relationship_id}>
            <label className="flex items-start gap-2 text-sm text-gray-800 dark:text-zinc-200">
              <input
                type="checkbox"
                className="mt-1 shrink-0"
                checked={link.share_end_customers}
                disabled={props.sharing}
                onChange={(e) => {
                  const next = e.target.checked;
                  const ok = next ? confirmShareOn(link.counterpart_name) : confirmShareOff(link.counterpart_name);
                  if (!ok) return;
                  void props.onSetShare(link.relationship_id, next);
                }}
              />
              <span>
                Share end-customer names, emails, phones, and addresses with{" "}
                <strong>{link.counterpart_name}</strong>
              </span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}

export function AudienceDataConsentCard(props: {
  links: SsdConsentLink[];
  sharing: boolean;
  onSetShare: (relationshipId: string, share: boolean) => Promise<boolean>;
  bare?: boolean;
}) {
  if (props.links.length === 0) return null;
  const body = (
    <ConsentList links={props.links} sharing={props.sharing} onSetShare={props.onSetShare} />
  );
  if (props.bare) return body;
  return (
    <SectionCard
      className="min-w-0 overflow-hidden"
      title="Share end customers"
      description="Dealer-controlled. Manufacturers see end-customer identity only when this is on."
    >
      {body}
    </SectionCard>
  );
}
